import Error from "@components/global/new/Error/Error";
import Option from "./Option/Option";
import WithModal, { CommonModalPropsI } from "@components/HOC/withModals";
import { AddPoolParams } from "@services/addPoolSettings";
import { ALGOS_E } from "@constants/Algos";
import { MODALS_ENUM } from "@constants/Modals";
import { useIntl } from "react-intl";
import styles from "./AddPoolSetting.module.scss";
import { MINER_POOLS } from "../../../../config";
import { IStoredSetting } from "@store/me/actionTypes";
import { IPoolCreds } from "@services/getSettings";
import { Input } from "@components/global/new/Input/Input";
import { Select } from "@components/global/new/Select/Select";
import { Button, Checkbox } from "antd";
import { useAddPoolSettingControl } from "./AddPoolSetting.control";
import { FieldError } from "@components/Pages/Settings/ErrorElemets";

export interface AddPooPropsI extends CommonModalPropsI {
  showCase?: boolean; // не понятно для чего, вроде не используется?
  edit?: boolean;
  setting: AddPoolParams;
  // for add new Miner
  id?: string;
  miner_id?: string;
  hash?: string;

  onSelectPool(p: IStoredSetting): void;
}

function AddPoolSetting(props: AddPooPropsI) {

  const { formatMessage } = useIntl();
  const control = useAddPoolSettingControl(props);

  return (
    <div className={styles.wrapper}>
      <div className={styles.head}>
        <h4>
          {props.edit
            ? `${formatMessage({ id: "modal.pool.title_edit" })} ${props.setting?.name}`
            : props.showCase
              ? formatMessage({ id: "modal.pool.title_proxy" })
              : formatMessage({ id: "modal.pool.title" })}
        </h4>
        {!props.showCase && !props.edit && (
          <Select
            wrapClassName={styles.algo}
            onChange={value => control.setAlgo(value)}
            value={control.algo}
            options={[
              {
                label: "SHA-256",
                value: ALGOS_E.SHA256,
              },
              {
                label: "SCRYPT",
                value: ALGOS_E.SCRIPT,
              },
              {
                label: "EQUIHASH",
                value: ALGOS_E.EQUIHASH,
              },
            ]}
          />
        )}
      </div>
      <form className={styles.content} onSubmit={control.formHandle}>
        <div className={styles.option_wrapper}>
          {!props.showCase && (
            <div className={styles.option}>
              <Input
                label={formatMessage({ id: "modal.pool.name" })}
                type='text'
                id='name'
                defaultValue={props.setting?.name}
                copyButton={props.showCase}
                disabled={props.showCase}
                readOnly={!!props.id}
                error={control.error?.name ? <FieldError errorStringId="notifications.error.name" /> : undefined}
              />
            </div>
          )}
        </div>

        {control.poolsToChange.map((p, i) => (
          <Option
            showCase={props.showCase}
            setting={p}
            optionNum={i + 1}
            key={p.address + i}
          />
        ))}
        {control.error && <Error errors={control.error} />}
        {control.error?.ownError && (
          <Checkbox
            checked={control.confirm}
            onClick={control.onConfirm}
          >
            {formatMessage({ id: "modal.pool.confirm_text" })}
          </Checkbox>
        )}
        {!props.showCase && (
          <div
            className={styles.btns}
            ref={(el) => control.setFormLastElement(el)}
          >
            <Button htmlType='button' onClick={props.handleClose}>
              {formatMessage({ id: "modal.pool.btn.cancel" })}
            </Button>
            <Button
              type="primary"
              htmlType='submit'
              disabled={!!control.error?.ownError && !control.confirm}
            >
              {formatMessage({ id: "modal.pool.btn.save" })}
            </Button>
          </div>
        )}
      </form>
    </div>
  );
}
export default WithModal(MODALS_ENUM.NEW_POOL_SETTINGS, AddPoolSetting);
